"use client";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useEffect, useState } from "react";

dayjs.extend(utc);

type LocalDateProps = {
  /** Unix timestamp in seconds */
  unix: number;
  /** dayjs format string, e.g. "MMMM D, YYYY" or "MMM D" */
  format: string;
  className?: string;
};

/**
 * Renders a post date in the reader's browser timezone.
 * SSR and the first client paint use UTC (matching prior static builds) to avoid
 * hydration mismatches; after mount the label updates to local time.
 */
export function LocalDate({ unix, format, className }: LocalDateProps) {
  const ms = unix * 1000;
  const iso = new Date(ms).toISOString();
  const utcLabel = dayjs.utc(ms).format(format);
  const [label, setLabel] = useState(utcLabel);

  useEffect(() => {
    setLabel(dayjs(ms).format(format));
  }, [ms, format]);

  return (
    <time dateTime={iso} className={className} suppressHydrationWarning>
      {label}
    </time>
  );
}
